'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrintButtonsToolbar = require('./components/PrintButtonsToolbar.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrintButtonsToolbar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/print/lib/components/print-buttons-toolbar/index.js
// module id = 1447
// module chunks = 1